// extracted by mini-css-extract-plugin
export default {"words":"styles_words__sWWIz"};